/* SimpleShots motion
   1. Scroll reveals — blocks fade + rise, headings reveal word-by-word,
      media settles from a slight zoom. One-shot IntersectionObserver.
   2. Magnetic buttons — pills drift toward the cursor inside a small radius
      and spring back when it leaves. Pointer devices only.
   Tags <html class="ss-js"> so the CSS only hides things when this runs.
   prefers-reduced-motion → nothing animates, nothing is hidden. */
(function () {
  var root = document.documentElement;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduce || !('IntersectionObserver' in window)) return;
  root.classList.add('ss-js');

  /* ---------------- 1. Reveals ---------------- */
  var BLOCKS = [
    '.ss-promise .ss-wrap > *',
    '.ss-pcard',
    '.ss-lifestyle .ss-cell',
    '.ss-founders > *',
    '.ss-cta-banner .ss-wrap > *',
    '.ss-pdetail-media', '.ss-pdetail-info',
    '.ss-value-item',
    '.ss-mission-band .ss-wrap > *',
    '.ss-story > *',
    '.ss-locator-hero .ss-wrap > *',
    '.ss-locator-band-content',
    '.ss-store-group-title', '.ss-store-row',
    '.ss-image-duo > *', '.ss-single-photo', '.ss-pack-facts .ss-wrap > *',
    '.ss-simple-page .ss-wrap > *',
    '.ss-enjoy-strip .ss-wrap > *'
  ].join(',');

  var HEADINGS = [
    '.ss-hero-text h1', '.ss-hero-content h1',
    '.ss-promise h2', '.ss-pcard h3', '.ss-lifestyle h2', '.ss-founders h2',
    '.ss-cta-banner h2', '.ss-pdetail-info h2', '.ss-mission-band h2',
    '.ss-locator-hero h1', '.ss-locator-band-content h3',
    '.ss-about-hero h1', '.ss-simple-page h1', '.ss-story h2'
  ].join(',');

  var MEDIA = [
    '.ss-founders img', '.ss-lifestyle .ss-cell img', '.ss-pdetail-media img',
    '.ss-story img', '.ss-image-duo img', '.ss-single-photo img'
  ].join(',');

  var WORD_STEP = 55;   // ms between words
  var BLOCK_STEP = 80;  // ms between sibling blocks

  // Split a plain-text heading into word spans. Skip anything with child elements.
  function splitWords(h) {
    if (h.dataset.ssSplit || h.children.length) return;
    var base = h.closest('.ss-hero-text, .ss-hero-content') ? 120 : 0; // hero h1 follows the eyebrow
    var text = h.textContent.replace(/\s+/g, ' ').trim();
    if (!text) return;
    var words = text.split(' ');
    var frag = document.createDocumentFragment();
    words.forEach(function (w, i) {
      var s = document.createElement('span');
      s.className = 'ss-w';
      s.textContent = w;
      s.style.transitionDelay = (base + i * WORD_STEP) + 'ms';
      frag.appendChild(s);
      if (i < words.length - 1) frag.appendChild(document.createTextNode(' '));
    });
    h.textContent = '';
    h.appendChild(frag);
    h.dataset.ssSplit = '1';
    h.classList.add('ss-words');
  }

  function inFold(el) {
    var r = el.getBoundingClientRect();
    return r.top < window.innerHeight * 0.92 && r.bottom > 0;
  }

  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (!e.isIntersecting) return;
      e.target.classList.add('ss-in');
      io.unobserve(e.target);
    });
  }, { rootMargin: '0px 0px -40px 0px', threshold: 0.12 });

  var pendingEls = [];
  // Fallback for jumps (anchor links, restored scroll): anything that ends up
  // above the viewport without ever intersecting gets revealed on the next scroll.
  var sweepTick = false;
  function sweep() {
    sweepTick = false;
    for (var i = pendingEls.length - 1; i >= 0; i--) {
      var el = pendingEls[i];
      if (el.classList.contains('ss-in')) { pendingEls.splice(i, 1); continue; }
      if (el.getBoundingClientRect().bottom < 0) { el.classList.add('ss-in'); io.unobserve(el); pendingEls.splice(i, 1); }
    }
  }
  window.addEventListener('scroll', function () { if (!sweepTick) { sweepTick = true; requestAnimationFrame(sweep); } }, { passive: true });

  function arm(el) {
    pendingEls.push(el);
    if (inFold(el)) {
      // Already on screen at load: play immediately (next frame so the
      // initial hidden state is painted first and the transition runs).
      requestAnimationFrame(function () { requestAnimationFrame(function () { el.classList.add('ss-in'); }); });
    } else {
      io.observe(el);
    }
  }

  // Headings: word reveal
  var headings = Array.prototype.slice.call(document.querySelectorAll(HEADINGS));
  headings.forEach(function (h) { splitWords(h); if (h.classList.contains('ss-words')) arm(h); });

  // Blocks: fade + rise, staggered among siblings. Don't double-hide a heading.
  var seen = new Map();
  Array.prototype.slice.call(document.querySelectorAll(BLOCKS)).forEach(function (el) {
    if (el.classList.contains('ss-words')) return;
    var p = el.parentNode, i = seen.get(p) || 0;
    seen.set(p, i + 1);
    el.style.setProperty('--ss-delay', Math.min(i * BLOCK_STEP, 400) + 'ms');
    el.classList.add('ss-reveal');
    arm(el);
  });

  // Media: settle from a slight zoom
  Array.prototype.slice.call(document.querySelectorAll(MEDIA)).forEach(function (img) {
    img.classList.add('ss-media');
    arm(img);
  });

  /* ---------------- 2. Magnetic buttons ---------------- */
  var finePointer = window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  if (finePointer) {
    var STRENGTH = 0.075;  // portfolio uses 0.28 — this is deliberately gentle (Nick: ~1/4 of that)
    var RADIUS = 90;       // px from the button's centre where the pull starts
    var mags = Array.prototype.slice.call(document.querySelectorAll('.ss-btn, .ss-nav-cta, .ss-gate-btn'));
    mags.forEach(function (b) { b.classList.add('ss-mag'); b._mx = 0; b._my = 0; });

    var pending = null;
    function track(x, y) {
      for (var i = 0; i < mags.length; i++) {
        var b = mags[i];
        var r = b.getBoundingClientRect();
        if (!r.width) continue;
        // Undo the current offset so the anchor point doesn't chase the cursor.
        var cx = r.left + r.width / 2 - b._mx;
        var cy = r.top + r.height / 2 - b._my;
        var dx = x - cx, dy = y - cy;
        var dist = Math.sqrt(dx * dx + dy * dy);
        var tx = 0, ty = 0;
        if (dist < RADIUS + Math.max(r.width, r.height) / 2) {
          // Ease the pull off toward the edge of the radius so entry/exit is soft.
          var falloff = Math.max(0, 1 - dist / (RADIUS + Math.max(r.width, r.height) / 2));
          tx = dx * STRENGTH * (0.6 + 0.4 * falloff);
          ty = dy * STRENGTH * (0.6 + 0.4 * falloff);
        }
        if (Math.abs(tx - b._mx) < 0.3 && Math.abs(ty - b._my) < 0.3) continue;
        b._mx = tx; b._my = ty;
        b.style.setProperty('--ss-mx', tx.toFixed(2) + 'px');
        b.style.setProperty('--ss-my', ty.toFixed(2) + 'px');
      }
    }
    document.addEventListener('mousemove', function (e) {
      if (pending) return;
      pending = requestAnimationFrame(function () { track(e.clientX, e.clientY); pending = null; });
    }, { passive: true });
    document.addEventListener('mouseleave', function () { track(-9999, -9999); });
  }

  /* ---------------- Header shadow ---------------- */
  var nav = document.querySelector('.ss-nav');
  if (nav) {
    var ticking = false;
    var update = function () { nav.classList.toggle('ss-scrolled', window.scrollY > 8); ticking = false; };
    window.addEventListener('scroll', function () { if (!ticking) { requestAnimationFrame(update); ticking = true; } }, { passive: true });
    update();
  }
})();
